import React, { FunctionComponent } from 'react'
import { Text } from '@afterpaytouch/core'
import { useTranslation } from '../../../../utils/convergence'
import styles from './style.module.css'

export const Terms: FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      <Text color='Gray40' size='XXS' fontFace='CashSansMono'>
        {t('educationIntro:terms')}
      </Text>
    </div>
  )
}
